import { PlanOptionNameEnum } from "@platform/openapi-types";

import { BenefitDefinition } from "../../../benefits/benefit.types";
import {
  createEnumFormatter,
  createValueFormatter,
} from "../../../components/PlanEditor/utilities/enumFormatters";
import * as sharedCellSpecs from "../cellSpecs/common";

// Editable, benefit-plan-level "Plan Option" field shared by every coverage.
// The dropdown selects a PlanOptionNameEnum value (persisted to
// proposal_plan.optionName via PATCH /proposal-plans/:id); free display text
// like "Silver/Bronze/Gold" is layered on through the Quotes field-override
// popup ("Enter Custom Text"), matching Funding Type's editing pattern.
export const planOptionNameDefinition: BenefitDefinition = {
  label: "Plan Option",
  description: "Plan option name (e.g. Low, High). Supports custom text.",
  cell: {
    ...sharedCellSpecs.enumDropdown,
    cellEditorParams: {
      allowTyping: true,
      values: Object.values(PlanOptionNameEnum),
      formatValue: createEnumFormatter(),
    },
    valueFormatter: createValueFormatter(),
  },
  networkDependent: false,
  benefitPlanLevel: true,
};
